// extracted by mini-css-extract-plugin
module.exports = {"s":"SmallText_s__lro1V"};